import { Injectable } from '@angular/core';
import { HomeService } from '../../pages/home/services/home.service';

@Injectable({
  providedIn: 'root'
})
export class PortalModulesService {
  modules: any;

  constructor(private homeService: HomeService) { }

  public setPortalModules(value: any) {
    this.modules = value;
    return this.modules;
  }

  public getPortalModules() {
    return this.modules;
  }
}
